// extracted by mini-css-extract-plugin
module.exports = {"dropdownItems":"DropdownItems__dropdownItems__Tyclm","classA":"DropdownItems__classA__VQBe8","classB":"DropdownItems__classB__RIv29","items":"DropdownItems__items__ug6Ff"};